import React, {Component} from 'react';
import axios from 'axios';
import config from "../config";
import withError from "../withError";
import i18n from "../i18n";
import ResultView from "../views/ResultView";

class ResultController extends Component {
  constructor(props) {
    super(props);
    this.state = {
      title: '',
      strengths: [],
      jobLikes: [],
      jobTypes: [],
      friend: '',
      tips: [],
      famousTitle: '',
      famousPeople: [],
      fictionalTitle: '',
      fictionalPeople: [],
      funTitle: '',
      funText: [],
      funAlt: '',
      funImage: ''
    };
  }

  componentDidMount() {

    axios.get(config.endpoints.type + '/' + this.props.answers.step1Letter + this.props.answers.step2Letter + this.props.answers.step3Letter + this.props.answers.step4Letter, {
      headers: {
        'Accept-Language': i18n.language
      }
    })
    .then(response => {
      this.setState({
        title: response.data.title,
        strengths: response.data.strengths,
        jobLikes: response.data.jobsList[0],
        jobTypes: response.data.jobsType,
        friend: response.data.friend,
        tips: response.data.tips,
        famousTitle: response.data.famousTitle,
        famousPeople: response.data.famousPeople,
        fictionalTitle: response.data.fictionalTitle,
        fictionalPeople: response.data.fictionalPeople,
        funTitle: response.data.funSection.title,
        funText: response.data.funSection.text,
        funAlt: response.data.funSection.altText,
        funImage: response.data.funSection.imageUrl
      });
    })
    .catch(error => {
      this.props.setError(error);
    });
  }

  render() {
    return <ResultView {...this.state} {...this.props}/>;
  }
}



export default withError(ResultController);
